import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type GetSelfReferralServiceInput = {
  selfReferralCode: Scalars['String']['input'];
};

export type InitialiseSelfReferralInput = {
  selfReferralCode: Scalars['String']['input'];
};

export type InitialiseSelfReferralResponse = {
  __typename?: 'InitialiseSelfReferralResponse';
  publicId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  initialiseSelfReferral: InitialiseSelfReferralResponse;
};


export type MutationInitialiseSelfReferralArgs = {
  input: InitialiseSelfReferralInput;
};

export type Organisation = {
  __typename?: 'Organisation';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getSelfReferralService: SelfReferralServiceResponse;
};


export type QueryGetSelfReferralServiceArgs = {
  input: GetSelfReferralServiceInput;
};

export type SelfReferralServiceResponse = {
  __typename?: 'SelfReferralServiceResponse';
  landingPageContent?: Maybe<Scalars['JSON']['output']>;
  organisation: Organisation;
  service: Service;
};

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
};

export type GetSelfReferralServiceQueryVariables = Exact<{
  input: GetSelfReferralServiceInput;
}>;


export type GetSelfReferralServiceQuery = { __typename?: 'Query', getSelfReferralService: { __typename?: 'SelfReferralServiceResponse', landingPageContent?: any | null, organisation: { __typename?: 'Organisation', code: string, name: string, shortName?: string | null, privacyPolicyUrl?: string | null }, service: { __typename?: 'Service', code: string } } };

export type InitialiseSelfReferralMutationVariables = Exact<{
  input: InitialiseSelfReferralInput;
}>;


export type InitialiseSelfReferralMutation = { __typename?: 'Mutation', initialiseSelfReferral: { __typename?: 'InitialiseSelfReferralResponse', publicId: string } };


export const GetSelfReferralServiceDocument = gql`
    query GetSelfReferralService($input: GetSelfReferralServiceInput!) {
  getSelfReferralService(input: $input) {
    organisation {
      code
      name
      shortName
      privacyPolicyUrl
    }
    service {
      code
    }
    landingPageContent
  }
}
    `;

export function useGetSelfReferralServiceQuery(options: Omit<Urql.UseQueryArgs<GetSelfReferralServiceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSelfReferralServiceQuery, GetSelfReferralServiceQueryVariables>({ query: GetSelfReferralServiceDocument, ...options });
};
export const InitialiseSelfReferralDocument = gql`
    mutation InitialiseSelfReferral($input: InitialiseSelfReferralInput!) {
  initialiseSelfReferral(input: $input) {
    publicId
  }
}
    `;

export function useInitialiseSelfReferralMutation() {
  return Urql.useMutation<InitialiseSelfReferralMutation, InitialiseSelfReferralMutationVariables>(InitialiseSelfReferralDocument);
};